import React from 'react';

import professor from 'assets/prof.png';

export const Loading = () => (
  <div className="verification verification-loading">
    <img src={professor} alt="Real Geeks Professor" />
    <h1>Working on it...</h1>
    <div>
      If you have any questions please contact
      {' '}
      <a href="https://www.realgeeks.com/support/">Real Geeks Support</a>
    </div>
  </div>
);
